import api from '../../api/api'
import url from '../../api/env'
import Utils from '../../utils/Utils'

const getAllStores = async () =>
  api
    .get(`${url.stage.stores_options}?paginate=0&sort_type=desc`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getAllUsers = async () =>
  api
    .get(`${url.stage.users}?paginate=0`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getDeposits = async (id, filter = '', excludeChars, sort_type = 'desc') =>
  api  
    .get(excludeChars ? `${url.stage.deposits}?sort_type=${sort_type}&store_id=${id}&per_page=5&deposit_number=%${encodeURIComponent(filter)}%` : encodeURI(`${url.stage.deposits}?sort_type=${sort_type}&store_id=${id}&per_page=5&deposit_number=%${filter}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getNextPage = async urlNextPage =>
  api
    .get(`${urlNextPage}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getStore = async id =>
  api
    .get(`${url.stage.storesCash}?id=${id}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const newCashAdjustment = async data =>
  api
    .post(`${url.stage.cashAdjustment}`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getStoreTurnByUser = async user =>
  api
    .get(`${url.stage.storeTurns}?open_by=${user}&is_open=1&paginate=0`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearFoAuthError() : console.log(err)))

export default {
  getAllStores,
  getDeposits,
  getAllUsers,
  getNextPage,
  getStore,
  newCashAdjustment,
  getStoreTurnByUser,
}
